// extracted by mini-css-extract-plugin
export default {"carosel_container":"splashCarosel_carosel_container__wO0OF"};